import { motion, useAnimation, useInView } from 'framer-motion';
import React, { useEffect, useRef } from 'react';
import Mobile from './Mobile';
import More from './More';
import "./skills.css";
import Web from './Web';

const Skills = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { 
    once: false,
    threshold: 0.2, // Trigger when 20% of element is visible
    margin: "0px 0px -200px 0px" // Negative margin to trigger earlier
  });
  const controls = useAnimation();

  useEffect(() => {
    if (isInView) {
      controls.start('visible');
    }
  }, [isInView, controls]);

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        delayChildren: 0.3,
        staggerChildren: 1.2 // Meningkatkan delay antar card
      }
    }
  };

  const skillVariants = {
    hidden: { 
      opacity: 0,
      y: 50,
      scale: 0.9
    },
    visible: (i) => ({
      opacity: 1,
      y: 0,
      scale: 1,
      transition: {
        type: "spring",
        damping: 15,
        stiffness: 100,
        delay: i * 1.2 // Menambah delay berdasarkan index
      }
    })
  };

  return (
    <motion.section 
      className="skills section" 
      id="skills"
      ref={ref}
      initial="hidden"
      animate={isInView ? "visible" : "hidden"}
      variants={containerVariants}
    >
      <motion.h2 
        className="section__title"
        initial={{ opacity: 0, y: -20 }}
        animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: -20 }}
        transition={{ duration: 0.5 }}
      >
        Skills
      </motion.h2>
      <motion.span 
        className="section__subtitle"
        initial={{ opacity: 0 }}
        animate={isInView ? { opacity: 1 } : { opacity: 0 }}
        transition={{ duration: 0.5, delay: 0.2 }}
      >
        My Technical Level
      </motion.span>

      <motion.div 
        className="skills__container container grid"
        variants={containerVariants}
      >
        {[
          { Component: Web, index: 0 },
          { Component: Mobile, index: 1 },
          { Component: More, index: 2 }
        ].map(({ Component, index }) => (
          <motion.div 
            key={index}
            custom={index}
            variants={skillVariants}
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
          >
            <Component />
          </motion.div>
        ))}
      </motion.div>
    </motion.section>
  );
};

export default Skills;